<template>
  <div class="d-flex align-items-center justify-space-between" id="auth_block" >
    <v-card class="mx-auto" width="40vw">
      <v-card-text>
        <p class="text-h4 text--primary">Вход</p>
        <p>Для получения всех функций, пожалуйста, введите пароль, выданный администратором системы.</p>
        <div class="text--primary">
          <v-text-field
              v-model="password"
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required, rules.min]"
              :type="show ? 'text' : 'password'"
              label="Пароль"
              counter
              @click:append="show = !show"
            ></v-text-field>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn dark color="warning"  @click="auth" :disabled="!password">Войти</v-btn>
      </v-card-actions>
    </v-card>

    <v-snackbar v-model="snackbar" absolute
      right
      rounded="pill"
      top>
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Login",
  data() {
    return {
      snackbar: false,
      text: null,
      show: false,
      show2: true,
      password: '',
      rules: {
        required: value => !!value || 'Без пароля войти не получится',
        min: v => v.length >= 8 || 'Мне кажется пароль короткий',
      },
    };
  },
  methods: {
    ...mapActions(["authenticate"]),
    async auth() {
      const password = btoa(this.password);
      await this.authenticate({ password })
        .catch((err) => {
          this.snackbar = true;
          this.text = err;
        });
    },
  },
};
</script>

<style scoped>

#auth_block{
  min-height: 92vh;
  align-items: center;
}
</style>